import React from 'react';
import RankingGame from '../components/ranking/RankingGame';
import RankingLeaderboard from '../components/ranking/RankingLeaderboard';
import { useQuestionRotation } from '../hooks/useQuestionRotation';
import Hero from '../components/ui/Hero';

const RankingGamePage = () => {
  const { currentQuestion, rotateQuestion } = useQuestionRotation();
  const heroImage = "https://nifmkzddenyukgjcdetc.supabase.co/storage/v1/object/public/animatronics_data/logo_light.webp?t=2024-12-30T20%3A06%3A02.198Z";

  return (
    <>
      {/* Mobile-only layout */}
      <div className="lg:hidden h-[100dvh] pt-16 flex flex-col overflow-hidden">
        <div className="flex-1 p-2 overflow-hidden">
          <div className="h-full">
            <RankingGame
              question={currentQuestion}
              onQuestionComplete={rotateQuestion}
            />
          </div>
        </div>
      </div>

      {/* Desktop layout */}
      <div className="hidden lg:block">
        <Hero
          title="Animatronic Ranking Game"
          description="Help us rank animatronics by voting in head-to-head matchups"
          backgroundImage={heroImage}
          compact
        />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2">
              <div className="card p-6">
                <RankingGame
                  question={currentQuestion}
                  onQuestionComplete={rotateQuestion}
                />
              </div>
            </div>

            <div className="lg:col-span-1">
              <div className="sticky top-24">
                <RankingLeaderboard />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RankingGamePage;